<app-new-note [moduleId]="moduleId" [entityId]="staffId" [breadCrumbInputs]="breadCrumbInputs"></app-new-note>